module.exports="#define GLSLIFY 1\nattribute vec4 position;\n\nvoid main() {\n  gl_Position = position;\n}\n";